export const Token = {
  generate: {
    url: "/token/generate",
    method: ["GET"],
    required: ["email"]
  }
};
